<template>
  <div>
    <div class="title">商家资质申请</div>
    <div class="step">
      <el-steps :active="active" align-center :space="200">
        <el-step
          title="同意入驻协议"
          icon="el-icon-document"
          space="50px"
        ></el-step>
        <el-step title="填写信息" icon="el-icon-edit" space="50px"></el-step>
        <el-step title="平台审核" icon="el-icon-s-check" space="50px"></el-step>
        <el-step
          title="签署协议"
          icon="el-icon-edit-outline"
          space="50px"
        ></el-step>
        <el-step title="完成" icon="el-icon-s-claim" space="50px"></el-step>
      </el-steps>
    </div>
    <div class="MerchantInformation">
      <span class="MerchantInformation_title">商家业务信息</span>
      <div class="address">
        <span><i style="color: red;">*</i> 公司名称：xxxxxxxxxxx</span>
        <div style="display: flex; align-items: center">
          <div class="label"><i style="color: red;">*</i> 办公地址：</div>
          <div class="field">
            <el-cascader
              size="mini"
              placeholder="请选择收货所在地"
              :options="pcaTextArr"
              v-model="process_plant"
              popper-class="popper"
              style="width: 220px"
            >
            </el-cascader>
          </div>
          <el-input
            size="mini"
            placeholder="详细地址"
            style="width: 220px; margin-left: 10px"
            v-model="detailedAddress"
          ></el-input>
        </div>
      </div>
      <div class="introductory">
        <span>公司简介：</span>
        <el-input
          class="textarea"
          type="textarea"
          :rows="4"
          placeholder="请输入公司简介"
          v-model="company_introduction"
          maxlength="200"
        >
        </el-input>
      </div>
    </div>
    <div class="MerchantInformation">
      <span class="MerchantInformation_title">法人信息</span>
      <div class="legalPerson">
        <span>法人姓名：xxxxxxxxxxx</span>
        <div style="display: flex; align-items: center">
          <div class="label"><i style="color: red;">*</i> 法人证件号码：</div>
          <el-input
            size="mini"
            placeholder="请输入身份证信息"
            style="width: 260px;"
            v-model="identityCard"
          ></el-input>
        </div>
      </div>
      <div class="legalPerson_img">
        <span><i style="color: red;">*</i> 法人证件：</span>
        <el-upload
          :action="uploadfile"
          class="unpload"
          :before-upload="beforeAvatarUpload"
          list-type="picture-card"
          :on-remove="handleRemove"
          :file-list="fileList"
          multiple
          :limit="2"
          :on-exceed="
            (file, fileList) => {
              handleExceed(file, fileList);
            }
          "
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <!-- <el-input
          class="textarea"
          type="textarea"
          :rows="3"
          placeholder="请输入公司简介"
          v-model="company_introduction"
          maxlength="200"
        >
        </el-input> -->
      </div>
    </div>
    <!-- <div class="MerchantInformation">
      <span class="MerchantInformation_title">授权书</span>
      <div class="legalPerson_img" style="margin: 0;margin-left: 20px;">
        <span><i style="color: red;">*</i> 授权书：</span>
        <el-upload
          :action="uploadfile"
          class="unpload"
          :before-upload="beforeAvatarUpload"
          list-type="picture-card"
          :on-remove="handleRemove"
          :file-list="fileList"
          multiple
          :limit="2"
          :on-exceed="
            (file, fileList) => {
              handleExceed(file, fileList);
            }
          "
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
    </div> -->
    <div class="MerchantInformation">
      <span class="MerchantInformation_title">联系人信息</span>
      <div class="legalPerson">
        <div>
            <span><i style="color: red;">*</i> 业务联系人：</span>
        <el-input
            size="mini"
            placeholder="请输入用户姓名或手机号码"
            style="width: 260px;"
            v-model="salesman"
          ></el-input>
        </div>
        <div style="display: flex; align-items: center">
          <div style="margin-left: 100px;"><i style="color: red;">*</i> 财务对账人：</div>
          <el-input
            size="mini"
            placeholder="请输入用户姓名或手机号码"
            style="width: 260px;"
            v-model="finance"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="MerchantInformation">
      <span class="MerchantInformation_title">商家收款信息</span>
      <div class="legalPerson" style="display: flex;flex-wrap: wrap;">
        <div>
            <span><i style="color: red;">*</i> 收款银行信息：</span>
        <el-input
            size="mini"
            placeholder=""
            style="width: 260px;"
            v-model="bankInformation"
          ></el-input>
        </div>
        <div style="display: flex; align-items: center;margin: 0 80px;">
          <div><i style="color: red;">*</i> 银行账号：</div>
          <el-input
            size="mini"
            placeholder=""
            style="width: 260px;"
            v-model="bankAccount"
          ></el-input>
        </div>
        <div style="display: flex; align-items: center">
          <div ><i style="color: red;">*</i> 开户行：</div>
          <el-input
            size="mini"
            placeholder=""
            style="width: 260px;"
            v-model="bankAddress"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" size="medium">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { pcaTextArr } from "element-china-area-data";
import { uploadfile } from "../../static/API/API.js";
import * as imageConversion from 'image-conversion'
export default {
  data() {
    return {
      active: 2,
      pcaTextArr,
      process_plant: [],
      detailedAddress: "",
      company_introduction: "",
      identityCard:'',
      salesman:'',
      finance:'',
      bankInformation:'',
      bankAccount:'',
      bankAddress:'',
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      //向后端传递的图片接口
      uploadfile: uploadfile,
      //商品主图
      fileList: [],
    };
  },
  methods: {
    // before-upload上传文件之前的钩子 -- 限制文件大小
    beforeAvatarUpload(file) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJpgOrPng) {
        this.$message.error("上传图片只能是JPG或PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return false;
      }
          return new Promise((resolve) => {
           // 以质量为0.6进行压缩，可自定义
          imageConversion.compress(file, 0.8).then((res) => {
            let fd = new FormData();
          fd.append('file', file); //传文件
          this.$axios.post(uploadfile, fd).then(res=> {
            console.log(res);
          })
              resolve(res)
          })

      })
    },
    // 删除
    handleRemove(file) {

    },
    handleExceed() {
      this.$message({
          title: "",
          message: "亲，最大支持2张图片哦~",
          type: "warning",
          duration: 1000,
          showClose: true,
        });
    },
  },
};
</script>

<style scoped>
.title {
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
  font-weight: 600;
}
/deep/ .el-step__title {
  font-size: 14px;
}
.step {
  margin: 25px 0;
  margin-left: -50px;
  /* margin-left: -5rem; */
  /* position: relative;
  left: -80px; */
}
/deep/ .el-step__icon-inner {
  border-radius: 50%;
  border: 1px solid;
  padding: 7px;
}
/deep/ .el-step__icon.is-finish {
  /* border-radius: 50%;
    border: 1px solid #eee;
    padding: 25px; */
  background: red;
}
/deep/ .el-step__icon-inner {
  margin-right: 0px;
}
/deep/ .el-step.is-horizontal .el-step__line {
  top: 14px;
}
/deep/ .el-step__title {
  margin-top: 10px;
}
.MerchantInformation {
    margin-bottom: 20px;
    font-size: 15px;
}
.MerchantInformation_title {
  display: inline-block;
  border-left: 4px solid #409eff;
  padding-left: 10px;
  margin-bottom: 25px;
  font-weight: 600;
}
.address,
.legalPerson {
  margin-left: 20px;
  display: flex;
  /* justify-content: space-between; */
}
.textarea {
  width: 70%;
}
.introductory,
.legalPerson_img {
  margin: 25px 0;
  margin-left: 20px;
  display: flex;
}
.label{
    margin-left: 300px;
}
.btn{
  display: flex;
  justify-content: center;
  margin: 35px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/qualificationApplication.vue